export default __webpack_public_path__ + "static/media/szafy3.a561d0a4.jpg";